export default "__VITE_ASSET__DkNHOe_f__"